import banner from "./banner/index";
import tracking from "./tracking/index";
import oauth from "./oauth/index";

module.exports = {
  banner,
  tracking,
  oauth
};



// WEBPACK FOOTER //
// ./plugins/index.js